
export enum ProjectEnum {
  Events = 1,
  Pos,
  Resy,
  QrMenu = 7,
  TimelyWork = 8

}
